import React, { FunctionComponent, useEffect, useRef, useContext } from "react";
import { IntlContext } from "../helpers";
import { FormattedMessage } from "react-intl-phraseapp";

interface FocusableHeaderProps {
  className?: string;
  text: string | { id: string; values: { [key: string]: string } };
  ignoreFocus?: boolean;
}

const FocusableHeader: FunctionComponent<FocusableHeaderProps> = ({
  className,
  text,
  ignoreFocus,
}) => {
  const ref = useRef<HTMLHeadingElement>(null);
  const fm = useContext(IntlContext).formatMessage;

  useEffect(() => {
    if (ref.current && !ignoreFocus) {
      ref.current.focus();
    }
  }, [ref, text, ignoreFocus]);

  useEffect(() => {
    document.title =
      typeof text === "string" ? text : fm({ id: text.id }, text.values);
  }, [text]);

  return (
    <h1 ref={ref} className={`${className}`} tabIndex={-1}>
      {typeof text === "string" ? (
        text
      ) : (
        <FormattedMessage id={text.id} values={text.values} />
      )}
    </h1>
  );
};

export default FocusableHeader;
